/**
 * AdaptiveDeviceTemplate: a page shell that follows the app shell's layout.
 * Under the touch shell (phones, tablets, narrow browser windows) it is a
 * scrolling stack padded clear of the bottom navigation; on the desktop shell
 * it is a full-height workspace. It never picks a look from the platform the
 * device reports, so a browser is not dressed as an iOS or macOS app.
 */
import { cn } from '../shared/ui/utils';
import { useAppShellFrame } from './shellFrame';
import {
  CollectionTemplate,
  WorkspaceTemplate,
  type TemplateProps,
} from './templates';

function TouchScreen({ className, contentClassName, ...props }: TemplateProps) {
  return (
    <CollectionTemplate
      {...props}
      className={cn('qs-device-shell qs-device-touch', className)}
      contentClassName={cn('qs-device-content qs-device-touch-content', contentClassName)}
    />
  );
}

function WorkspaceScreen({ className, contentClassName, ...props }: TemplateProps) {
  return (
    <WorkspaceTemplate
      {...props}
      className={cn('qs-device-shell qs-device-workspace', className)}
      contentClassName={cn('qs-device-content qs-device-workspace-content', contentClassName)}
    />
  );
}

export function AdaptiveDeviceTemplate(props: TemplateProps) {
  const { shellPlatform } = useAppShellFrame({});

  return shellPlatform === 'touch'
    ? <TouchScreen {...props} />
    : <WorkspaceScreen {...props} />;
}
